import i18n, { use } from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import moment from "moment-timezone";
import { initReactI18next } from "react-i18next";

import { LS_LANGUAGE, LS_LANGUAGE_CHATBOT } from "~constants";
import IFrameHelper from "~helpers/IFrameHelper";
import StorageHelper from "~helpers/StorageHelper";
import TokenHelper from "~helpers/TokenHelper";

import en from "./locales/en.json";
import tr from "./locales/tr.json";

import "moment/locale/tr";

const resources = {
  tr: {
    translation: tr,
  },
  en: {
    translation: en,
  },
};

const getDefaultLanguage = () => (IFrameHelper.isWebChatMode() ? "tr" : "en");
const currentLanguageKey = IFrameHelper.isWebChatMode()
  ? LS_LANGUAGE_CHATBOT.format(TokenHelper.getWebchatProjectToken())
  : LS_LANGUAGE;
StorageHelper.get(currentLanguageKey)
  .catch(() => {
    const browserLang = navigator?.language?.split("-")?.[0];
    return browserLang || getDefaultLanguage();
  })
  .then((defaultLang) => {
    i18n.on("initialized", (options) => {
      let lang = options.lng;
      if (lang) {
        moment.locale(lang);
      }
    });
    i18n.on("languageChanged", (lng) => {
      moment.locale(lng);
    });

    const languageDetector = new LanguageDetector();
    languageDetector.addDetector({
      name: "palamarDetector",
      lookup: () => {
        //parse url and get language
        const url = new URL(window.location.href);
        const lang = url.searchParams.get(LS_LANGUAGE);
        if (lang) {
          return lang;
        }
        return defaultLang || getDefaultLanguage();
      },
      cacheUserLanguage: (lang) => {
        StorageHelper.set(currentLanguageKey, lang);
      },
    });

    use(languageDetector)
      .use(initReactI18next) // passes i18n down to react-i18next
      .init({
        resources,
        fallbackLng: "en",
        interpolation: {
          escapeValue: false, // react already safes from xss
        },
        detection: {
          lookupQuerystring: LS_LANGUAGE,
          lookupCookie: currentLanguageKey,
          lookupLocalStorage: currentLanguageKey,
          order: ["palamarDetector", "querystring", "localStorage", "cookie", "navigator"],
          caches: ["localStorage"],
        },
      });
  });

export const i18Languages = resources;
